export default {"src":"/_next/static/media/meter-low.c872b4df.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};